import styled from "styled-components";
import Heading from "./../../atoms/Heading";

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 100px;

  &.reverse {
    flex-direction: column-reverse;
  }

  @media (min-width: 990px) {
    padding-bottom: 80px;
  }

  > div {
    margin-bottom: 25px;
  }
`;

export const MainHeading = styled(Heading)`
  position: relative;
  //margin-top: 100px;
  margin-bottom: 12px;
  padding-top: 0;
  padding-bottom: 0;
  letter-spacing: -1.33px;

  &.active {
    margin-top: 0;
  }

  & + p {
    margin: 0 0 20px 0;
  }

  @media (min-width: 990px) {
    margin-top: 0;
    margin-bottom: 20px;
    padding-top: 30px;
    padding-left: 0;
    font-size: 37px;

    & + p {
      margin-top: -10px;
    }
  }
`;

export const BackButton = styled.button`
  position: absolute;
  top: 37px;
  left: -40px;
  border: none;
  background: none;
  padding: 0;
  outline: none;
  cursor: pointer;
  user-select: none;
  outline: none;
  box-shadow: none;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }

  svg {
    display: block;
  }

  svg path {
    fill: var(--color-primary);
  }
`;

export const BackLink = styled.a`
  position: absolute;
  top: 37px;
  left: -40px;
  border: none;
  background: none;
  padding: 0;
  outline: none;
  cursor: pointer;
  user-select: none;
  outline: none;
  box-shadow: none;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }

  svg {
    display: block;
  }

  svg path {
    fill: var(--color-primary);
  }
`;

export const Breakfasts = styled.div`
  margin: 0 -24px;
  padding: 16px 24px;
  background: rgba(255, 139, 0, 0.05);
  border-radius: 3px;

  @media (min-width: 990px) {
    margin: 0;
    padding: 16px;
    padding-top: 25px;
    border: solid 1px rgba(255, 139, 0, 0.2);
  }
`;

export const Entrees = styled.div`
  margin: 0 -24px;
  padding: 16px 24px;
  border-radius: 3px;

  @media (min-width: 990px) {
    margin: 0;
    padding: 16px;
    padding-top: 25px;
  }
`;

export const SectionHeading = styled.h3`
  margin: 0 0 10px 0;
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: -0.45px;

  @media (min-width: 990px) {
    font-size: 28px;
  }
`;

export const SectionWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
`;

export const BreakfastsSectionHeading = styled(SectionHeading)`
  color: var(--color-primary);
`;

export const EntreeSectionHeading = styled(SectionHeading)`
  color: var(--color-secondary);
`;
